import React from "react";
import { Typography, Button, Badge } from "antd";
import { DashboardOutlined, MessageOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useSignalR } from "Common/hooks/context/SingleRContext";
const { Title } = Typography;
const Header = () => {
  const { unreadMessages } = useSignalR();
  const navigate = useNavigate();
  const styles = {
    badgeIcon: {
      fontSize: 20,
    },
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 24,
      }}
    >
      <Title level={2} style={{ margin: 0, color: "#1a1a1a" }}>
        <DashboardOutlined /> Mentor Dashboard
      </Title>
      <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
        <Badge count={unreadMessages} size="small" offset={[0, 6]}>
          <Button
            type="text"
            onClick={() => navigate("/messaging")}
            icon={<MessageOutlined style={styles.badgeIcon} />}
            shape="circle"
          />
        </Badge>
      </div>
    </div>
  );
};
export default Header;
